import React from "react";
import { animated } from "react-spring";
import { PlacementGroup } from "../../../../SubComponents";

const middleStyles = {
  beatsaber: {
    regular: "translate(220px, 45px) scale(1.3)",
    phone: "translate(10px , 300px) scale(1.75)",
  },
  electronicarts: {
    regular: "translate(20px,300px) scale(0.11)",
    phone: "translate(390px, 120px) scale(0.12)",
  },
  oralb: {
    regular: "translate(510px, 300px) scale(1.5)",
    phone: "translate(960px, -50px) scale(1.8)",
  },
  bumble: {
    regular: "translate(445px, 490px) scale(1.55)",
    phone: "translate(480px, 315px) scale(2)",
  },
  aok: {
    regular: "translate(1220px,120px) scale(0.08)",
    phone: "translate(1445px, 320px) scale(0.05)",
  },
  liebherr: {
    regular: "translate(1240px,380px) scale(0.26)",
    phone: "translate(1180px, 330px) scale(0.25)",
  },
  levis: {
    regular: "translate(960px,400px) scale(2)",
    phone: "translate(1240px, -50px) scale(2.1)",
  },
};

const Bumble = () => (
  <PlacementGroup pos={middleStyles.bumble}>
    <path
      d="m171.65,20.74c.42,5.34,7.78,6.26,10.79,2.91.42-.6,1.8-1.32,2.94-.61,3.48,4.09-4.15,7-7.89,6.59-13.34.8-13.95-21.89.16-21.33,6.41,0,9.84,4.29,9.84,10.74.07.71-.35,1.69-1.1,1.7,0,0-14.74,0-14.74,0h0Zm11.65-3.77c-.78-6.18-10.79-5.89-11.65,0h11.65Zm-23.71,6.4c-.08,1.69,1.68,2.15,3.25,2,2.15-.33,3.05,3.22.81,3.8-3.62,1.55-8.68-1.03-8.58-5.2,0,0,0-21.7,0-21.7.09-2.88,4.4-2.91,4.51,0,0,0,0,21.11,0,21.11h.01Zm-18.04,6.26c-2.63.11-5.16-1.02-6.84-3.04.37,2.9-4.43,3.28-4.53.36,0,0,0-24.68,0-24.68.09-2.89,4.44-2.91,4.53,0,0,0,0,9.33,0,9.33,14.42-12.79,25,16.74,6.84,18.03Zm-.42-16.43c-8.49-.51-8.49,12.58,0,12.06,7.8.48,7.96-12.48,0-12.06Zm-16.23,13.94c-.12,2.89-4.4,2.9-4.52,0,0,0,0-9.54,0-9.54-.41-6.9-10.21-5.87-9.05,1.96,0,0,0,7.58,0,7.58-.12,2.89-4.41,2.9-4.52,0-.54-3.65,2.14-14.63-4.14-14.31-3.2,0-4.91,2.28-4.91,6.73-.43,2.04,1.49,9.88-2.26,9.85-1.22-.08-2.19-1.05-2.26-2.27,0,0,0-15.83,0-15.83.13-2.88,4.39-2.89,4.52,0,2.56-3.7,10.03-3.68,12.05.83,3.97-6.08,15.29-3.68,15.1,4.61,0,0,0,10.4,0,10.4h-.01Zm-41.47.2c-4.17,4.83-15.1,2.01-14.32-5.82,0,0,0-10.21,0-10.21.11-2.88,4.41-2.89,4.52,0,0,0,0,9.37,0,9.37-.53,6,8.01,6.87,9.8,1.64-.02-1.23.01-9.18,0-11.02.11-2.88,4.43-2.89,4.53,0,0,0,0,16.02,0,16.02-.04,2.69-4.49,2.69-4.53,0v.02Zm-27.83,2.3c-2.63.11-5.17-1.02-6.85-3.05.37,2.91-4.43,3.28-4.52.36,0,0,0-24.68,0-24.68.09-2.89,4.43-2.91,4.52,0,0,0,0,9.33,0,9.33,14.43-12.79,25.01,16.73,6.85,18.03h0Zm-.42-16.44c-8.5-.52-8.5,12.58,0,12.06,7.79.48,7.95-12.47,0-12.06Zm-21.3.78c.39.68.39,1.52,0,2.2l-7.45,12.88c-.39.68-1.12,1.1-1.9,1.1h-14.9c-.78,0-1.51-.42-1.9-1.1L.29,16.18c-.39-.68-.39-1.52,0-2.2L7.73,1.1C8.13.42,8.85,0,9.63,0h14.9c.78,0,1.5.42,1.9,1.1,0,0,7.45,12.88,7.45,12.88Zm-9.28,2.99c2.42.03,2.43-3.81,0-3.77,0,0-15.03,0-15.03,0-2.44-.04-2.45,3.81,0,3.77,0,0,15.02,0,15.02,0h.01Zm-5.24,6.4c2.4.04,2.4-3.8,0-3.77,0,0-4.57,0-4.57,0-1.02,0-1.85.85-1.85,1.89s.83,1.88,1.85,1.88c.01,0,4.56,0,4.57,0ZM12.94,6.8c-2.43-.04-2.42,3.8,0,3.77,0,0,8.28,0,8.28,0,1.03,0,1.87-.85,1.87-1.89s-.84-1.88-1.87-1.88h-8.28Z"
      fill="#FFC629"
    />
  </PlacementGroup>
);

const Levis = () => (
  <PlacementGroup pos={middleStyles.levis}>
    <path
      d="m61.4,19.73c-4.69,0-5.55-2.75-5.55-3.43h3.4c.1.84,1.35,1.35,2.16,1.27h0c2.32.12,2.19-1.73.05-1.76-2.41-.35-5.79-.76-5.79-3.5-.07-5.78,12.15-4,11.58-.47h-3.45c-.5-2.71-6.96-.37-2.42.52,6.77-.26,9.75,6.85.03,7.37h0Zm-5.76-9.68l-1.32,1.46h-.55l.61-1.59h-1.21v-2.12h2.48v2.25Zm-7.69-1.34h4.39v10.71h-4.39v-10.71Zm-5.73,10.73h-3.84l-5.73-10.71h5.17c.12.25,3.27,6.45,3.38,6.71.1-.29,3.04-6.44,3.16-6.71h3.1l-5.24,10.71Zm-8.24-4.45h-8.89c.04,1.43,1.29,2.55,2.72,2.44h0c.93.05,1.82-.38,2.35-1.14h3.54c-2.16,5.7-13.7,4.1-13.27-2.18-.35-8.36,15.16-6.63,13.54.91v-.02s0,0,0,0Zm-13.62,4.43h-10.13v-10.69h4.55v7.78h5.57v2.91ZM62.66,0H0l7.41,32c15.56-10.14,30.5-.4,31.11-.02h0s.01,0,.01,0c.6-.37,15.55-10.11,31.1.02L77.05,0c-3.05,0-11.23,0-14.39,0ZM27.15,10.7c-1.14,0-2.07.91-2.07,2.05h0v.1s0,0,0,0h4.3c.09-1.24-1.01-2.29-2.25-2.14h0s0,0,0,0Z"
      fill="#C41230"
    />
  </PlacementGroup>
);

const Aok = () => (
  <PlacementGroup pos={middleStyles.aok}>
    <path
      fill="#005E3F"
      d="M2851.21,584.95c21.89,22.32,51.39,34,81.23,34c19.6,0,39.32-5,57.05-15.23
	c50.39-29.09,54.97-76.02,82.69-179.49c-67.02-17.96-108.83-32.5-143.7-32.5c-18.76,0-35.52,4.21-53.1,14.36
	c-47.42,27.38-65.86,81.75-52.31,129.83l-67.84,39.17V411.63c48.75-12.07,86.87-55.64,86.87-110.65
	c0-58.04-38.65-85.91-114.1-161.36c-75.75,75.75-114.1,103.18-114.1,161.36c0,52.07,35.84,98.22,86.67,110.69v163.4l-67.81-39.15
	c13.54-48.09-4.9-102.45-52.31-129.82c-17.58-10.15-34.34-14.36-53.1-14.36c-34.87,0-76.68,14.54-143.7,32.5
	c27.72,103.47,32.3,150.4,82.69,179.49c17.73,10.24,37.45,15.23,57.05,15.23c29.84,0,59.34-11.69,81.23-34l95.95,55.4v80.12
	l-234.66-0.01v54.66l523.98,0.02v-54.66l-234.66-0.01v-80.12L2851.21,584.95z M2874.94,489.9c3.95-15.45,13.81-28.4,27.78-36.47
	c8.77-5.06,16-7.04,25.78-7.04c17.81,0,43.06,6.63,77.26,16.18c-17.07,66.1-23.5,82.2-43.6,93.8c-8.96,5.18-19.24,7.91-29.72,7.91
	c-21.51,0-40.75-11.09-51.47-29.66C2873.28,521.3,2871.08,505,2874.94,489.9z M2574.88,534.63c-10.72,18.57-29.97,29.66-51.47,29.66
	c-10.48,0-20.75-2.73-29.72-7.91c-20.1-11.61-26.53-27.71-43.6-93.8c34.2-9.54,59.46-16.18,77.27-16.18
	c9.77,0,16.99,1.97,25.76,7.04C2581.5,469.83,2591.26,506.25,2574.88,534.63z M2668.57,300.99c0-23.21,10.73-36.83,59.43-84.66
	c48.7,47.86,59.44,61.53,59.44,84.66c0,32.77-26.66,59.43-59.43,59.43C2695.23,360.42,2668.57,333.76,2668.57,300.99z M2728,56.04
	c244.8,0,443.96,199.16,443.96,443.96S2972.8,943.96,2728,943.96S2284.04,744.8,2284.04,500S2483.2,56.04,2728,56.04 M2728,1
	c-275.58,0-499,223.45-499,499c0,275.58,223.42,499,499,499c275.55,0,499-223.42,499-499C3227,224.45,3003.56,1,2728,1L2728,1z
	 M1079.28,127.61c-205.65,0-372.37,166.74-372.37,372.37c0,205.65,166.72,372.37,372.37,372.37
	c205.63,0,372.37-166.72,372.37-372.37C1451.65,294.36,1284.91,127.61,1079.28,127.61z M1079.29,750.33
	c-136.83,0-247.73-112.12-247.73-250.34s110.9-250.29,247.73-250.29c136.81,0,247.76,112.08,247.76,250.29
	S1216.09,750.33,1079.29,750.33z M2118.92,848.25h-164.87h-0.03l-224.37-296.26l-98.08,109.55l0.16,186.71h-120.84V151.67h120.22
	l0.29,330.44l296.14-330.44h160.52l-272.32,304.15L2118.92,848.25z M458.16,151.67L1,848.26h145.47l97.92-149.89h288.07v149.89
	h120.16V151.67H458.16z M315.61,589.36l216.78-331.84l0.07,331.84H315.61z"
    />
  </PlacementGroup>
);

const Liebherr = () => (
  <PlacementGroup pos={middleStyles.liebherr}>
    <path
      d="M238.9,95.2h31.4V124h-89.9V0h89v28.8h-30.6v19.8h27.9v26.1h-27.9v20.5H238.9z M101.3,124h59.3V0h-59.3V124z M58.4,0H0v124
	h85.4V90.8h-27V0z M654.1,74.6H682V48.5h-27.9V28.8h30.6V0h-89v124h89.9V95.2h-31.5V74.6z M423.4,90.7c0,16.2-9.5,26.8-25.7,30.7
	c-7.1,1.7-18.6,2.6-29,2.6h-80.5V0h80c10.2,0,21.4,0.9,28.4,2.6c15.8,3.9,25.1,14.5,25.1,30.7c0,14.9-8.8,25.1-20,28.4
	C413.7,64.4,423.4,75,423.4,90.7 M344.7,50.3h8.1c10.8,0,14.4-5.4,14.4-13s-3.6-13-14.4-13h-8.1V50.3z M369,86.3
	c0-8.1-3.7-13.5-15.3-13.5h-9v27h9C365.4,99.7,369,94.3,369,86.3 M517,45.8h-19.8V0h-58.4v124h58.4V76.4H517V124h58.4V0H517V45.8z
	 M967.9,72.3c15.3-7,22.1-18.6,22.1-34.4c0-18.4-11-30.4-29.4-34.9c-8.1-1.9-21.2-3-33-3h-71.9v124h55.7V84.5h5l21.1,39.5h62.5
	L967.9,72.3z M919.5,58.4h-8.1V28.8h8.1c10.8,0,14.4,5.4,14.4,14.8S930.3,58.4,919.5,58.4z M815.4,72.3c15.3-7,22.1-18.6,22.1-34.4
	c0-18.4-11-30.4-29.4-34.9c-8.1-1.9-21.2-3-33-3h-71.9v124h55.7V84.5h5L785,124h62.5L815.4,72.3z M766.9,58.4h-8.1V28.8h8.1
	c10.8,0,14.4,5.4,14.4,14.8S777.7,58.4,766.9,58.4z"
    />
  </PlacementGroup>
);
const OralB = () => (
  <PlacementGroup pos={middleStyles.oralb}>
    <path
      fill="#1574C4"
      d="M104.7,23.24h-5.55l-0.91,4.21h5.7C106.9,27.44,107.21,23.24,104.7,23.24z"
    />
    <path
      fill="#1574C4"
      d="M106.68,3.43H21.83c-9.91,0-17.95,8.03-17.95,17.95c0,9.91,8.04,17.94,17.95,17.94h84.85
	c9.91,0,17.94-8.03,17.94-17.94C124.62,11.47,116.59,3.43,106.68,3.43z M23.57,34.48c-8.32,0-11.78-5.25-11.84-11.04
	C11.68,15.01,17.29,7.78,26.58,7.8c8.13,0.02,11.9,5.08,11.84,11.13C38.36,24.85,34.73,34.51,23.57,34.48z M62,33.92v-1.17
	c-4.56,3.28-11.71,1.78-11.7-3.85c0.01-4.66,4.63-5.68,5.7-5.87c5-0.91,8.42-0.82,8.75-2.21c0.4-1.72-4.33-1.89-4.68,0.68h-9.92
	c-1.47,0-3.37,0.72-4.16,4.47l-1.71,7.97h-7.25l3.93-18.29h6.28v1.88c0.91-0.98,2.83-3.28,6.66-2.13l-0.79,3.68
	c2.31-3.26,5.72-3.93,9.62-3.95c4.98-0.01,9.92,1.96,8.92,6.59l-2.08,9.66c-0.29,1.32-0.02,1.87,0.29,2.55H62z M78.8,33.93h-7.41
	l5.49-25.41h7.42L78.8,33.93z M113.81,25.99c0,2.21-1.75,7.94-10.07,7.94H89.09l2.3-10.7h-6.11l1.08-4.97h6.1l2.09-9.73h9.97
	c3.22,0,10.59-0.55,10.63,5.87c0,2.79-1.05,4.86-4.08,6.5C112.58,22.09,113.82,23.02,113.81,25.99z"
    />
    <path
      fill="#1574C4"
      d="M105.88,14.49h-4.85l-0.82,3.78h4.97C108.33,18.27,108.92,14.49,105.88,14.49z"
    />
    <path
      fill="#1574C4"
      d="M57.54,28.29c0,2.21,4.78,2.32,5.97-2.75C60.65,26.41,57.54,26.58,57.54,28.29z"
    />
    <path
      fill="#1574C4"
      d="M26.1,14.22c-3.36,0-6.27,3.44-6.26,9.64c0,2.62,1.36,4.34,4.06,4.34c4.86,0,6.3-6.85,6.31-9.67
	C30.22,16.23,28.85,14.22,26.1,14.22z"
    />
  </PlacementGroup>
);
const ElectronicArts = () => (
  <PlacementGroup pos={middleStyles.electronicarts}>
    <path
      fill="#FF4747"
      d="M500.02,0C-157,11.69-157.11,988.22,500,1000C1157,988.31,1157.1,11.78,500.02,0z M302.05,306.61h282.57
	l-43.2,68.9H259.18L302.05,306.61z M785.29,651.05l-45.47-68.72H608.85l41.88-68.96h44.22l-49.05-74.46L511.4,651.05H147.21
	l87.27-137.68h-62.9l43.86-68.93h265.5l-43.87,68.93H322.23l-44.21,68.96h191.61l172.74-275.06l226.45,343.78H785.29z"
    />
  </PlacementGroup>
);
const Beatsaber = () => (
  <PlacementGroup pos={middleStyles.beatsaber}>
    <path
      fill="#046DBC"
      d="M18.81,50c-3.17-2.11-7.3-2.61-10.35-4.47c-0.85-0.67-1.02-1.18-1.02-1.9c0.17-2.64,2.19-3.01,4.74-3.14
	c1.5,0,2.73,0.35,3.6,0.98c1.13,0.96,1.72,2.3,3.37,2.23c2.32,0.1,3.87-2.85,2.42-4.72c-3.48-5.2-12.38-5.76-16.97-2.09
	C0.56,40.14,0.4,47.04,4.8,50.22c2.14,1.62,4.69,2.2,7.09,3.18c2.15,0.78,4.94,1.45,4.93,4.03c-0.44,4.54-8.37,3.96-10.11,0.67
	c-2.12-3.19-7.03-0.11-5,3.21c4,6.87,16.42,7.29,20.18-0.02C23.84,57.3,22.48,52.49,18.81,50z M21.07,60.35
	c-3.45,6.07-14.72,5.56-18.2-0.17c-0.24-0.42-0.14-0.98,0.28-1.22c0.49-0.24,1.15-0.13,1.61,0c1.43-0.63,1.91,1.78,3.11,2.23
	c3.31,2.76,10.51,1.34,10.43-3.77c-0.29-6.36-8.94-5.68-12.82-8.83c-3.35-2.4-3.2-7.6-0.17-10.09c4.05-2.94,12.5-2.85,15.62,1.71
	c0.28,0.38,0.18,0.98-0.21,1.26c-0.33,0.22-0.74,0.22-1.04,0c-0.25,0.17-0.56,0.19-0.82,0.1c-0.37,0.12-0.79,0.03-1.01-0.31
	c-1.28-1.76-3.14-2.61-5.46-2.78c-4.84-0.28-8.32,5.41-4.17,8.68C13.68,50.35,24.67,51.12,21.07,60.35z"
    />
    <path
      fill="#046DBC"
      d="M46.59,57.23c-0.37-0.89-0.97-1.7-1.76-2.21c0.46-1.08,0.48-2.27,0.04-3.36L40,37.41
	c-1.24-3.9-7.24-3.93-8.48,0.03c0,0-8.55,25.08-8.55,25.08c-1.29,3.69,4.27,5.68,5.62,1.96c3.48-9.47,0.29-4.79,5.59-4.26
	c0,0,7.16,0,7.16,0l1.58,4.29c0.79,2.48,4.49,2.63,5.5,0.27C49.48,63.18,46.94,58.8,46.59,57.23z M47.05,64.37
	c-0.28,0.11-0.58,0.04-0.82-0.13c-0.49,0.33-1.76,0.31-1.95-0.43c0,0-1.92-5.2-1.92-5.2c-0.14-0.28-0.38-0.45-0.7-0.45h-6.45
	c-0.36,0-1.26,0-1.62,0c-2.85,0.05-2.86-4.45,0-4.4c1.09-0.02,5.54,0.01,6.7,0c0.18,0,0.28-0.1,0.35-0.17
	c0.06-0.06,0.13-0.36,0-0.56c0,0-4.66-13.54-4.66-13.54l-8.33,24.33c-0.2,0.57-0.89,0.82-1.37,0.44c-0.33,0.29-0.74,0.09-1.12,0.18
	c-0.6-0.04-1.07-0.61-0.84-1.22c0,0,8.56-25.11,8.56-25.11c0.46-1.43,2.03-1.81,3.37-1.55c1.18-0.27,2.43,0.4,2.82,1.55
	c0,0,4.89,14.28,4.89,14.28c0.65,1.42-0.49,3.25-2.06,3.21c-0.39,0-1.24,0-1.62,0c0,0-5.09,0-5.09,0c-0.46-0.02-0.46,0.72,0,0.7
	c0,0,6.45,0,6.45,0c1.56-0.08,3.37-0.07,4.03,1.64c0,0,1.92,5.24,1.92,5.24C47.78,63.67,47.54,64.2,47.05,64.37z M32.9,51.88
	l2.87-8.38l2.82,8.19C37.62,51.73,33.76,51.53,32.9,51.88z"
    />
    <path
      fill="#046DBC"
      d="M68.26,49.25c4.62-5.79-0.15-14.98-7.51-14.72c-4.01,0.34-11.73-1.76-11.99,4.48c0,0,0,23.12,0,23.12
	c0,2.47,2.02,4.48,4.51,4.48h8.87C71.11,66.97,75.54,54.57,68.26,49.25z M68.66,62.31c-1.85,1.91-4.53,2.4-7.1,2.23
	c-1.2,0-7.81,0-8.87,0c-1.36,0-2.44-1.08-2.44-2.41V39.02c0.09-2.31,2.18-2.56,4.06-2.41c1.22,0,6.36,0,7.47,0
	c5.66-0.22,9.42,6.84,5.9,11.35c-0.31,0.41-0.85,0.52-1.27,0.22c-0.24,0.17-0.53,0.21-0.81,0.11c-0.8,0.32-1.59-0.71-1.04-1.41
	c0.66-0.91,1.01-1.96,1.01-3.11c-0.34-6.34-6.78-5.29-11.27-5.31c-0.35,0-0.59,0.24-0.59,0.56v23.12c0,0.31,0.24,0.56,0.59,0.56
	c4.96-0.12,12.86,1.44,13.19-5.83c0-3.21-2.65-5.83-5.9-5.83h-5.12c-0.84-0.08-2.52,0.38-2.56-0.91c0.05-1.26,1.72-0.84,2.56-0.91
	c0,0,5.12,0,5.12,0C69.1,48.17,74.09,56.71,68.66,62.31z M64.09,43.77c0,0.71-0.2,1.32-0.6,1.87c-0.61,0.6-0.23,1.81-1.31,1.51
	c-0.24,0.04-7.53-0.08-7.43,0.08c0,0,0-6.7,0-6.7C57.64,40.8,63.98,39.17,64.09,43.77z M54.75,60.63v-7.6
	c0.22,0.05,0.45,0.08,0.69,0.08h6.74c3.31-0.09,5.15,4.15,2.69,6.42C63.4,61.44,56.8,60.37,54.75,60.63L54.75,60.63z"
    />
    <path
      fill="#046DBC"
      d="M90.57,40.53c3.87-0.01,3.91-5.97,0-5.99c0,0-14.07,0-14.07,0c-2.47,0-4.48,2.02-4.48,4.51v8.42
	c0,0.72,0.24,1.37,0.63,1.88c-0.4,0.68-0.63,1.47-0.63,2.31V62.1c0,2.49,2.01,4.51,4.48,4.51h14.07c1.64,0,2.98-1.35,2.98-3.01
	c0-1.64-1.33-2.98-2.98-2.98h-12.6v-7.46h12.6c1.64,0,2.98-1.35,2.98-3.01c0-1.66-1.33-3.01-2.98-3.01h-12.6v-6.62
	C77.97,40.53,90.57,40.53,90.57,40.53z M89.99,49.21c0.37-0.02,1.24,0.01,1.62,0c1.17-0.01,1.18,1.9,0,1.89c-0.34,0-13.24,0-14.07,0
	c-0.32,0-0.59,0.24-0.59,0.56V62.1c0,0.35,0.28,0.59,0.59,0.59c0.85,0,13.72,0,14.07,0c1.19-0.01,1.16,1.87,0,1.85
	c-1.8,0-13.23,0-15.11,0c-1.51,0.2-3.01-0.8-2.99-2.45c0,0,0-10.44,0-10.44c0.12-2.35,2.12-2.59,4.03-2.44
	C77.53,49.21,89.99,49.21,89.99,49.21z M77.53,38.46c-0.32,0-0.59,0.24-0.59,0.59v8.42c0.04,0.74-0.85,1.22-1.43,0.76
	c-0.21,0.17-0.54,0.24-0.81,0.12c-0.59,0.23-1.22-0.25-1.2-0.88c0,0,0-8.42,0-8.42c0-1.36,1.08-2.44,2.41-2.44
	c2.32,0,13.37,0,15.69,0c1.18,0,1.16,1.86,0,1.85C91.26,38.46,78.36,38.46,77.53,38.46z"
    />
    <path
      fill="#046DBC"
      d="M98.51,38.91v11.42c0.58-1.34,2.27-1.17,3.49-1.15c0,0,4.81,0,4.81,0c7.12-0.13,7.12-10.72,0-10.83
	c0,0-7.71,0-7.71,0C98.79,38.35,98.51,38.6,98.51,38.91z M99.55,40.42h7.85c4.39-0.01,4.37,6.67,0,6.69c0,0-6.42,0-6.42,0
	c-0.5,0-0.98,0.09-1.42,0.25C99.55,47.36,99.55,40.42,99.55,40.42z"
    />
    <path
      fill="#046DBC"
      d="M117.56,62.15l-4.45-8.83c-1.45-1.93-0.55-1.6,0.89-2.99c1.74-1.74,2.7-4.07,2.7-6.56
	c-0.75-11.01-10.69-9.3-18.62-9.33c-2.47,0-4.48,2.01-4.48,4.48v24.62c0.02,3.88,5.96,3.91,5.95,0c0,0,0-8.38,0-8.38
	c0.44,0.16,0.92,0.25,1.42,0.25h5.9c0.38,0,0.74,0.23,0.91,0.54l4.44,8.84C113.93,68.36,119.37,65.67,117.56,62.15z M116.36,64.34
	c-0.37,0.26-0.77-0.14-1.04,0c-0.59,0.13-1.49,0.22-1.8-0.42c0,0-4.47-8.91-4.47-8.91c-1.03-2.42-5.05-1.52-7.05-1.68
	c-1.24,0.03-2.92,0.18-3.49-1.18v11.38c0.03,0.73-0.85,1.17-1.42,0.73c-0.66,0.35-2.01,0.29-2.01-0.73c0,0,0-24.62,0-24.62
	c0.11-2.33,2.14-2.54,4.03-2.41c0,0,7.71,0,7.71,0h0.58c11.32-0.59,10.7,15.73-0.58,14.49c0,0-4.81,0-4.81,0
	c-0.33-0.01-0.31,0.52,0,0.52c0.33,0,4.7,0,4.87,0c2.13-0.21,4.49,0.62,5.4,2.69c0,0,4.47,8.87,4.47,8.87
	C116.99,63.53,116.81,64.09,116.36,64.34z"
    />
    <path
      fill="#FF9088"
      d="M3.45,60.18c-0.29-0.48-0.08-1.17,0.48-1.3c-2.86-0.07,0.25,3.17,1.25,3.78c1.79,1.29,4.14,1.95,6.72,1.88
	C8.26,64.45,5.32,63.1,3.45,60.18z"
    />
    <path
      fill="#FF9088"
      d="M17.03,61.19c1.97-1.34,2.35-4.3,1.22-6.25c-2.59-3.85-8.69-3.64-12.19-6.36c-5.61-4.47-1-12.59,5.82-11.97
	c-7.07-0.85-12.27,7.12-6.4,11.97c3.49,2.71,9.6,2.5,12.19,6.35c2.18,3.75-1.32,7.7-5.3,7.73C14.06,62.73,15.75,62.15,17.03,61.19z"
    />
    <path
      fill="#FF9088"
      d="M17.07,39.85c-1.22-0.88-2.9-1.43-4.68-1.38c2.31,0.17,4.18,1.02,5.46,2.78c0.23,0.34,0.64,0.44,1.02,0.31
	C18.15,41.17,17.8,40.31,17.07,39.85z"
    />
    <path
      fill="#FF9088"
      d="M31.98,55.95c0-1.22,0.98-2.2,2.2-2.2c-3.67-0.44-3.66,4.84,0,4.4C32.95,58.15,31.98,57.18,31.98,55.95z"
    />
    <path
      fill="#FF9088"
      d="M24.92,63.22l8.56-25.11c0.32-0.89,1.06-1.48,1.98-1.58c-1.13-0.15-2.19,0.51-2.56,1.58
	c0,0-8.56,25.11-8.56,25.11c-0.29,0.71,0.48,1.43,1.16,1.16C25,64.25,24.74,63.71,24.92,63.22z"
    />
    <path
      fill="#FF9088"
      d="M41.23,53.58c0.06-0.07,0.13-0.36,0-0.56c-0.05,0-4.9-14.51-4.97-14.32c0,0-0.27,0.78-0.27,0.78l4.66,13.54
	c0.18,0.39,0.04,0.69-0.35,0.73C40.53,53.75,41.11,53.82,41.23,53.58z"
    />
    <path
      fill="#FF9088"
      d="M44.86,63.81l-1.92-5.2c-0.2-0.52-0.83-0.47-1.28-0.45c0.31,0,0.56,0.17,0.7,0.45l1.92,5.2
	c0.17,0.49,0.71,0.74,1.16,0.56C45.18,64.28,44.96,64.1,44.86,63.81z"
    />
    <path
      fill="#FF9088"
      d="M54.5,50.12c0-0.49,0.42-0.91,0.94-0.91c-2.03-0.3-2.03,2.13,0,1.82C54.92,51.03,54.5,50.65,54.5,50.12z"
    />
    <path
      fill="#FF9088"
      d="M65.15,46.87c2.77-3.61-0.5-8.94-4.98-8.42c2.97,0,5.41,2.38,5.41,5.31c0,1.15-0.35,2.2-1.01,3.11
	c-0.56,0.7,0.24,1.73,1.04,1.41C65.02,48.12,64.76,47.37,65.15,46.87z"
    />
    <path
      fill="#FF9088"
      d="M50.83,62.13V39.02c0-1.33,1.08-2.41,2.44-2.41c-1.53-0.2-3.05,0.81-3.03,2.41c0,0,0,23.12,0,23.12
	c-0.02,1.6,1.5,2.61,3.03,2.41C51.91,64.54,50.83,63.46,50.83,62.13z"
    />
    <path
      fill="#FF9088"
      d="M66.33,60.98c3.96-3.7,0.6-10.55-4.74-9.95c7.8,0.16,7.71,11.57-0.04,11.66
	C63.32,62.79,65.08,62.26,66.33,60.98z"
    />
    <path
      fill="#FF9088"
      d="M74.08,62.1V51.66c0-1.33,1.08-2.44,2.41-2.44c-1.52-0.2-3,0.84-2.99,2.45c0,0,0,10.44,0,10.44
	c-0.01,1.64,1.48,2.64,2.99,2.44C75.17,64.54,74.08,63.46,74.08,62.1z"
    />
    <path
      fill="#FF9088"
      d="M74.08,47.47v-8.42c0-1.36,1.08-2.44,2.41-2.44c-1.52-0.2-3,0.8-2.99,2.45c0,0,0,8.42,0,8.42
	c-0.02,0.63,0.61,1.12,1.2,0.88C74.34,48.23,74.08,47.89,74.08,47.47z"
    />
    <path
      fill="#FF9088"
      d="M112.23,43.77c0,2.97-2.41,5.41-5.41,5.41c7.89,0.44,7.88-11.29,0-10.83
	C109.82,38.35,112.23,40.76,112.23,43.77z"
    />
    <path
      fill="#FF9088"
      d="M95.66,63.53V38.91c0-1.33,1.08-2.41,2.41-2.41c-1.51-0.2-3.01,0.81-2.99,2.41c0,0,0,24.62,0,24.62
	c-0.01,0.64,0.64,1.07,1.2,0.85C95.93,64.27,95.66,63.95,95.66,63.53z"
    />
    <path
      fill="#FF9088"
      d="M98.88,51.24c0-1.15,0.94-2.06,2.1-2.06c-0.98-0.1-2.05,0.24-2.46,1.16c0,0,0,1.82,0,1.82
	c0.41,0.93,1.47,1.29,2.46,1.18C99.82,53.33,98.88,52.39,98.88,51.24z"
    />
    <path
      fill="#FF9088"
      d="M114.1,63.92l-4.47-8.9c-0.65-1.23-2-1.8-3.34-1.68c1.15,0,2.2,0.66,2.76,1.68l4.47,8.9
	c0.19,0.41,0.66,0.58,1.09,0.45C114.39,64.29,114.21,64.14,114.1,63.92z"
    />
    <path
      fill="#20BEFF"
      d="M12.21,62.73c0.16,0,0.31-0.03,0.47-0.03c-0.27-0.03-0.52,0-0.79,0.01C12.01,62.71,12.1,62.73,12.21,62.73z"
    />
    <path
      fill="#20BEFF"
      d="M12.18,38.42c-0.1,0-0.19,0.02-0.3,0.02c0.28,0.01,0.53,0.05,0.81,0.01C12.51,38.45,12.35,38.42,12.18,38.42z"
    />
    <path
      fill="#FFFFFF"
      d="M11.89,64.53c0.26,0.01,0.53,0.01,0.79-0.01C12.42,64.51,12.16,64.53,11.89,64.53z"
    />
    <path
      fill="#FFFFFF"
      d="M4.4,59.24c0.6-0.2,0.07-0.56-0.48-0.36C4.11,58.94,4.28,59.06,4.4,59.24z"
    />
    <path
      fill="#FFFFFF"
      d="M19.36,41.13c-0.09,0.21-0.27,0.38-0.5,0.43C19.3,41.7,19.93,41.57,19.36,41.13z"
    />
    <path
      fill="#FFFFFF"
      d="M12.69,36.62c-0.27-0.01-0.54-0.02-0.81-0.01C12.16,36.62,12.42,36.64,12.69,36.62z"
    />
    <path
      fill="#FFFFFF"
      d="M36.26,36.56c-0.26-0.06-0.54-0.08-0.81-0.04C35.75,36.56,35.98,36.68,36.26,36.56z"
    />
    <path
      fill="#E5451A"
      d="M21.08,31.56h8.87c5.28,0.13,9.92-4.7,9.48-9.98c-0.13-2.31-1.12-4.52-2.77-6.13c-0.28-0.45-1.4-0.74-0.77-1.21
	c4.35-5.62-0.27-14.38-7.33-14.13c0,0-7.47,0-7.47,0c-2.32,0-4.2,1.87-4.2,4.17v23.12C16.88,29.69,18.76,31.56,21.08,31.56z
	 M18.15,4.49c0.03-2.47,2.94-2.79,4.84-2.62c0,0,5.57,0,5.57,0c4.32-0.63,8.68,2.59,8.57,7.16c0.02,1.3-0.87,5.71-2.71,4.23
	c-0.46,0.38-1.18,0.79-1.74,0.39c-0.42-0.28-0.52-0.87-0.21-1.29c2.6-3.37-0.13-8.54-4.4-8.42c0,0-5.53,0-5.53,0
	c-0.25,0.17-0.08,1.3-0.13,1.54c3.12,0.25,9.68-1.37,9.8,3.55c0,0.77-0.22,1.45-0.66,2.05c-0.7,0.84-0.15,2.02-1.56,1.64
	c0,0-6.74,0-6.74,0c-0.29,0-0.57,0.06-0.83,0.14v1.9c0.53-0.37,2.01-0.29,2.65-0.28c0,0,4.93,0,4.93,0
	c2.47-0.17,5.01,0.33,6.77,2.24c4.65,4.44,1.28,13.29-5.26,13.1c-1.33,0.35-9.39,0.18-10.9,0.21c-1.36,0-2.44-1.08-2.44-2.41
	C18.15,27.6,18.15,4.48,18.15,4.49z"
    />
    <path
      fill="#E5451A"
      d="M32.02,27.57c5.61-2.41,3.59-11.26-2.53-11.07c0,0-6.74,0-6.74,0c-0.12,0-0.24-0.02-0.34-0.06v1.47
	c0.23,0.29,7.1,0.07,7.58,0.14c3.58-0.09,5.56,4.5,2.91,6.95c-1.58,2.05-8.29,0.93-10.49,1.2c0.08,0.47-0.29,1.8,0.57,1.76
	C24.56,27.82,30.63,28.28,32.02,27.57z"
    />
    <path
      fill="#E5451A"
      d="M39.44,22.68c0.02,3.49-0.83,8.67,4.17,8.89c0,0,14.07,0,14.07,0c3.45-0.03,3.49-5.34,0-5.37
	c0,0-12.91,0-12.91,0v-8.08h12.91c1.47,0,2.67-1.21,2.67-2.7c0-1.49-1.2-2.7-2.67-2.7H44.77V5.47h12.91c3.46-0.01,3.51-5.35,0-5.37
	c0,0-14.07,0-14.07,0c-2.3,0-4.17,1.89-4.17,4.2v8.42c0,0.72,0.27,1.37,0.71,1.85C38.83,16.45,39.67,20.54,39.44,22.68z M40.7,4.52
	c0.02-2.39,2.7-2.84,4.57-2.66c0,0,12.4,0,12.4,0s1.1,0,1.1,0c1.14-0.01,1.11,1.87,0,1.85c0,0-1.04,0-1.04,0
	c-0.15,0.13-0.34,0.21-0.55,0.21H44.84c-0.08,0.1-0.14,0.23-0.14,0.38c0,0,0,8.42,0,8.42c0.05,1.13-1.61,1.27-1.72,0.14
	c-0.17,1.09-2.29,1.49-2.28,0.08C40.7,12.94,40.71,4.52,40.7,4.52z M40.7,17.13c0.02-2.36,2.71-2.85,4.57-2.66c0,0,12.4,0,12.4,0
	h1.1c1.12-0.01,1.13,1.9,0,1.89c-0.21,0.26-13.12,0.23-13.94,0.21c-0.08,0.1-0.13,0.21-0.13,0.35v10.44c0,0.35,0.27,0.59,0.57,0.59
	h12.4c0.7-0.02,1.99-0.15,1.97,0.91c0.01,1.08-1.19,0.97-1.92,0.94c-0.15,0.13-0.34,0.21-0.55,0.21H43.12
	c-1.33,0-2.41-1.08-2.41-2.44L40.7,17.13z"
    />
    <path
      fill="#E5451A"
      d="M39.46,22.12c0-0.18-0.02-0.36-0.03-0.54v1.09C39.45,22.49,39.46,22.31,39.46,22.12z"
    />
    <path
      fill="#E5451A"
      d="M60.32,29.09c0.22,2.75,4.3,3.22,5.16,0.55c0,0,2.3-6.73,2.3-6.73c0.64,1.34,2,2.26,3.58,2.26h7.37l1.66,4.49
	c1.2,3.32,6.21,1.47,5.02-1.83c-0.87-1.78-1.73-6.54-3.78-7.44c0.54-1.07,0.59-2.28,0.15-3.37L76.9,2.77
	C75.74-0.86,70.15-0.89,69,2.8c0,0-8.55,25.08-8.55,25.08C60.29,28.27,60.36,28.68,60.32,29.09z M61.62,28.69l8.56-25.11
	c0.87-2.29,5.27-2.68,6.14-0.21c0,0,4.69,14.28,4.69,14.28c0.3,0.73,0.2,1.54-0.2,2.2c-0.51,0.84-1.43,1.09-2.33,1.01
	C78,21.27,72.96,21,72.3,21.08c-0.14,0.21,0.04,0.5,0.29,0.48c0,0,6.84,0,6.84,0c1.29-0.13,2.71,0.23,3.18,1.61
	c0.08,0.03,1.83,5.23,1.88,5.27c0.29,0.88-0.57,1.41-1.29,1.19c-0.57,0.29-1.35,0.46-1.64-0.35c0,0-1.92-5.2-1.92-5.2
	c-0.14-0.28-0.38-0.45-0.7-0.45h-8.07c-2.48,0.08-3-3.68-0.64-4.3c0.57-0.42,1.68-0.3,2.35-0.32c0,0,5.35,0,5.35,0
	c0.07-0.08,0.09-0.34-0.02-0.52c0,0-4.66-13.54-4.66-13.54l-7.92,24.12c-0.23,0.77-1.28,0.82-1.6,0.13
	C63.18,30.15,61.22,30.15,61.62,28.69z M69.57,17.68l3.38-9.88l3.25,9.46C74.88,17.35,70.72,16.94,69.57,17.68z"
    />
    <path
      fill="#E5451A"
      d="M60.32,29.09c0.03-0.17,0.02-0.34-0.01-0.5C60.3,28.75,60.3,28.92,60.32,29.09z"
    />
    <path
      fill="#E5451A"
      d="M88.23,5.44h6.09c-0.11,0.37-0.17,0.77-0.17,1.18v22.28c0,1.47,1.2,2.67,2.67,2.67s2.67-1.2,2.67-2.67V7.78
	c3.21-0.06,8.43,0.92,8.59-3.82c0-2.12-1.71-3.85-3.82-3.85H88.23C84.74,0.13,84.74,5.42,88.23,5.44z M87.65,2.1
	c1.22-0.59,15.6-0.06,17.19-0.23c2.55-0.03,2.59,4.18,0,4.16c-0.36,0.01-0.67,0.25-1.07,0.21c0,0-5.05,0-5.05,0
	c-0.09,0.11-0.15,0.24-0.15,0.38v22.28c0,0.49-0.37,0.91-0.87,0.91c-0.3-0.07-0.47-0.15-0.77-0.02c-0.53,0.52-1.53,0.09-1.51-0.67
	c0,0,0-22.28,0-22.28c0-1.92,2.07-2.79,3.72-2.62c0,0,4.86,0,4.86,0c0.05-0.14-0.09-0.31-0.23-0.31c0,0-16.03,0-16.03,0
	C86.64,3.93,86.52,2.19,87.65,2.1z"
    />
    <path
      fill="#FF9C94"
      d="M20.67,3.86c-0.02,0.02-0.04,0.04-0.06,0.07C20.67,3.94,20.67,3.91,20.67,3.86z"
    />
    <path
      fill="#FF9C94"
      d="M22.63,14.71c-0.23,0-0.23,0.07-0.22,0.27C22.47,14.88,22.54,14.79,22.63,14.71z"
    />
    <path
      fill="#FF9C94"
      d="M45.27,3.71C43,4.21,57.65,3.8,57.19,3.93c0.21,0,0.39-0.09,0.55-0.21C57.7,3.71,45.32,3.71,45.27,3.71z"
    />
    <path
      fill="#FF9C94"
      d="M99.14,6.02c-0.17,0-0.31,0.09-0.42,0.21c0.67-0.07,5.44,0.2,5.94-0.21h-0.41H99.14z"
    />
    <path
      fill="#20BEFF"
      d="M22.25,17.86c0.11,0.03-0.23,8.65,0.17,8.33C22.33,26.15,22.61,17.63,22.25,17.86z"
    />
    <path
      fill="#20BEFF"
      d="M22.25,12.9c0.35,0.26,0.09-7.42,0.17-7.43c0,0-0.17,0-0.17,0V12.9z"
    />
    <path
      fill="#20BEFF"
      d="M35.82,9.02c0,1.54-0.49,2.97-1.36,4.19c-0.09,0.06,0.07,0.15,0.12,0.21c1.89,0.81,2.49-3.04,2.55-4.4
	c0.11-4.57-4.25-7.8-8.57-7.16C32.4,1.77,35.9,5.15,35.82,9.02z"
    />
    <path
      fill="#20BEFF"
      d="M20.64,4.27v23.12c-0.23,0.96,1.82,0.43,2.35,0.56c-0.85,0.03-0.5-1.27-0.57-1.76c0,0-0.17,0-0.17,0
	s0-8.33,0-8.33c0.05,0.02,0.11,0.03,0.17,0.05v-1.47c-0.35-0.13-0.6-0.44-0.6-0.84c0-0.38,0.25-0.7,0.6-0.84v-1.9
	c-0.06,0.02-0.11,0.03-0.17,0.05V5.47c0,0,0.17,0,0.17,0v-1.2c0-0.13,0.05-0.25,0.12-0.35c0,0-1.87,0-1.87,0
	C20.65,4.04,20.64,4.15,20.64,4.27z"
    />
    <path
      fill="#20BEFF"
      d="M37.71,22.12c0.09,3.76-2.89,6.91-6.46,7.68c10.96-0.27,9.7-16.59-1.26-15.33C34.1,14.39,37.79,18,37.71,22.12z
	"
    />
    <path
      fill="#20BEFF"
      d="M29.95,29.8c0.92,0.08,2.02-0.09,2.83-0.53C31.89,29.61,30.93,29.8,29.95,29.8z"
    />
    <path
      fill="#20BEFF"
      d="M21.81,15.59c0,0.4,0.25,0.72,0.6,0.84c0.04-0.3-0.05-0.77-0.11-1.06c0-0.22,0.15-0.41,0.11-0.63
	C22.06,14.89,21.81,15.22,21.81,15.59z"
    />
    <path
      fill="#20BEFF"
      d="M22.98,3.71c-0.31,0.08-2.21-0.21-2.31,0.21c0,0,1.87,0,1.87,0C22.64,3.8,22.79,3.71,22.98,3.71z"
    />
    <path
      fill="#20BEFF"
      d="M58.59,15.41c0,0.52-0.4,0.86-0.85,0.94c0.73,0.02,1.93,0.14,1.92-0.94c0.01-1.11-1.24-0.95-1.97-0.94
	C58.17,14.47,58.59,14.89,58.59,15.41z"
    />
    <path
      fill="#20BEFF"
      d="M58.59,2.77c0,0.52-0.4,0.86-0.85,0.94c0.73,0.02,1.93,0.14,1.92-0.94c0.01-1.07-1.26-0.92-1.97-0.91
	C58.17,1.86,58.59,2.28,58.59,2.77z"
    />
    <path
      fill="#20BEFF"
      d="M43.01,16.92v10.44c-0.03,0.97,1.74,0.48,2.26,0.59c-0.3,0-0.57-0.24-0.57-0.59V16.92
	c0-0.13,0.06-0.25,0.13-0.34h-1.69C43.07,16.67,43.01,16.78,43.01,16.92z"
    />
    <path
      fill="#20BEFF"
      d="M58.59,28.86c0,0.52-0.4,0.86-0.85,0.94c0.73,0.02,1.93,0.14,1.92-0.94c0.01-1.07-1.26-0.92-1.97-0.91
	C58.17,27.95,58.59,28.37,58.59,28.86z"
    />
    <path
      fill="#20BEFF"
      d="M43.01,4.31v8.42c-0.15,1.21,1.76,1.23,1.69,0c0,0,0-8.42,0-8.42c0-0.15,0.06-0.28,0.14-0.38h-1.69
	C43.07,4.03,43.01,4.16,43.01,4.31z"
    />
    <path
      fill="#20BEFF"
      d="M45.27,3.71c-0.36,0.06-1.89-0.18-2.12,0.21c0,0,1.69,0,1.69,0C44.95,3.8,45.1,3.71,45.27,3.71z"
    />
    <path
      fill="#20BEFF"
      d="M57.68,29.8c0.02,0,0.07,0,0.08-0.02C57.73,29.79,57.71,29.8,57.68,29.8z"
    />
    <path
      fill="#20BEFF"
      d="M45.27,16.36c-0.36,0.06-1.89-0.18-2.12,0.21c0,0,1.69,0,1.69,0C44.94,16.44,45.1,16.36,45.27,16.36z"
    />
    <path
      fill="#20BEFF"
      d="M57.68,16.36c0.02,0,0.07,0,0.08-0.02C57.73,16.34,57.71,16.36,57.68,16.36z"
    />
    <path
      fill="#20BEFF"
      d="M57.68,3.71c0.02,0,0.07,0,0.08-0.02C57.73,3.7,57.71,3.71,57.68,3.71z"
    />
    <path
      fill="#20BEFF"
      d="M72.5,3.79c-0.14,0.13-8.59,25.11-8.68,25.28c-0.2,0.34,0.41,0.6,0.69,0.63c0.37,0,0.7-0.25,0.84-0.63
	l7.92-24.12C73.14,4.65,72.97,3.68,72.5,3.79z"
    />
    <path
      fill="#20BEFF"
      d="M71.01,21.21c-0.05,0.61,1.27,0.26,1.58,0.35c-0.25,0.01-0.42-0.27-0.28-0.49
	C72.23,21.13,70.91,20.94,71.01,21.21z"
    />
    <path
      fill="#20BEFF"
      d="M81.81,23.17c0.07,0.01,1.92,5.24,1.96,5.27c0.16,0.46-0.05,0.94-0.48,1.14c0.7,0.39,1.5-0.41,1.21-1.14
	c0,0-1.84-5.24-1.84-5.24c-0.51-1.38-1.89-1.79-3.22-1.64C80.48,21.56,81.42,22.19,81.81,23.17z"
    />
    <path
      fill="#20BEFF"
      d="M75.24,3.37l4.89,14.28c0.6,1.34-0.3,2.85-1.65,3.21c1.76,0.32,3.25-1.55,2.53-3.21c0,0-4.69-14.28-4.69-14.28
	c-0.38-1.17-1.62-1.84-2.78-1.53C74.32,2.03,74.96,2.58,75.24,3.37z"
    />
    <path
      fill="#20BEFF"
      d="M72.59,20.86c-0.25,0.06-1.45-0.18-1.52,0.21c0,0,1.24,0,1.24,0C72.36,20.95,72.44,20.86,72.59,20.86z"
    />
    <path
      fill="#20BEFF"
      d="M78.07,20.86c0.16,0,0.48,0.02,0.61-0.1C78.48,20.82,78.28,20.86,78.07,20.86z"
    />
    <path
      fill="#20BEFF"
      d="M73.49,3.96c-0.24-0.5-0.65-0.5-0.99-0.17c0.46-0.09,0.65,0.83,0.77,1.16C73.29,4.83,73.63,4.06,73.49,3.96z"
    />
    <path
      fill="#20BEFF"
      d="M106.32,3.96c0.01,1.04-0.75,1.75-1.65,2.06c3.12,0.03,2.66-4.66-0.4-4.16C105.41,1.86,106.32,2.81,106.32,3.96
	z"
    />
    <path
      fill="#20BEFF"
      d="M97.73,6.61v22.28c0,0.33-0.18,0.61-0.45,0.77c0.56,0.39,1.32-0.11,1.3-0.77c0,0,0-22.28,0-22.28
	c0-0.14,0.06-0.27,0.15-0.38C98.4,6.28,97.68,6.04,97.73,6.61z"
    />
    <path
      fill="#20BEFF"
      d="M104.26,6.02c0.14,0,0.46,0.03,0.57-0.09C104.64,5.98,104.46,6.02,104.26,6.02z"
    />
    <path
      fill="#20BEFF"
      d="M99.14,6.02c-0.32,0.03-1.04-0.12-1.26,0.21c0,0,0.84,0,0.84,0C98.83,6.11,98.98,6.02,99.14,6.02z"
    />
    <path
      fill="#FFFFFF"
      d="M83.02,29.66c0.09-0.01,0.19-0.01,0.26-0.08C83.14,29.44,83.13,29.54,83.02,29.66z"
    />
    <path
      fill="#FFFFFF"
      d="M96.93,29.78c0.13-0.02,0.24-0.05,0.35-0.11C97.09,29.49,97.07,29.64,96.93,29.78z"
    />
  </PlacementGroup>
);

const LogosLayerMiddle = (props) => (
  <animated.g {...props}>
    <Beatsaber />
    <ElectronicArts />
    <OralB />
    <Bumble />
    <Aok />
    <Liebherr />
    <Levis />
  </animated.g>
);

export default LogosLayerMiddle;
